import createNamespaceContext from './helper/createNamespaceContext';
export var GROWTH_CONTEXT = 'editionAwarenessCtx';
export var GrowthAnalyticsContext = createNamespaceContext(GROWTH_CONTEXT, 'GrowthAnalyticsContext');